export default "__VITE_ASSET__PlsjiRpn__"